import { createApi, createAxiosInstance } from 'common/api'

export type CustomerAttributesResponse = {
  fileName: string
  type: string
  created: string
  result: Object[] // can really be anything that the customer uploads
}
export type CustomerAttributesResponse2 = {
  name: string
  id: string
  description: string
}

export const getCustomerAttributes = async ({
  accountId,
  baseUrl,
}: {
  accountId: string
  baseUrl: string | undefined
}): Promise<CustomerAttributesResponse> => {
  if (!baseUrl) {
    throw new Error('Base URL is not defined')
  }

  const dataIngestionClient = createAxiosInstance(baseUrl)
  const api = createApi(dataIngestionClient)
  const result = await api.get<CustomerAttributesResponse>(
    `accounts/${accountId}/data/customer`
  )

  return result.data
}

export const getCustomerAttributes2 = async ({
  accountId,
  baseUrl,
}: {
  accountId: string
  baseUrl: string | undefined
}): Promise<CustomerAttributesResponse2> => {
  if (!baseUrl) {
    throw new Error('Base URL is not defined')
  }

  const dataIngestionClient = createAxiosInstance(baseUrl)
  const api = createApi(dataIngestionClient)
  // TODO update once BE is ready
  const result = await api.get<CustomerAttributesResponse2>(
    `accounts/${accountId}/data/customer`
  )

  return result.data
}

// TODO update once BE is ready
export const updateCustomerAttributes = async ({
  accountId,
  baseUrl,
}: {
  accountId: string
  baseUrl: string
}): Promise<void> => {
  const dataIngestionClient = createAxiosInstance(baseUrl)
  const api = createApi(dataIngestionClient)
  await api.post<void>(`accounts/${accountId}/data/customer`)
}

export type ProductCatalogResponse = {
  _id: string
  file_name: string // name of the file
  type: string
  created: string
  categories: { productCategories: Object } // can really be anything
}

export const getProductCatalog = async ({
  accountId,
  baseUrl,
}: {
  accountId: string
  baseUrl: string | undefined
}): Promise<ProductCatalogResponse | null> => {
  if (!baseUrl) {
    throw new Error('Base URL is not defined')
  }

  const dataIngestionClient = createAxiosInstance(baseUrl)
  const api = createApi(dataIngestionClient)
  const result = await api.get<ProductCatalogResponse | null>(
    `accounts/${accountId}/data/product/category`
  )

  return result.data
}

export const getCustomerAttributeRecords = async ({
  accountId,
}: {
  accountId: string
}) => {
  return Promise.resolve([
    {
      id: '1',
      name: 'EU Customer data',
      region: 'EU',
      updated: '2021-09-01',
    },
  ])
}
